<i18n
  src="@/locales/components/views/agro_exporter/production/query_container_export/exportation_status.yml"
  lang="yaml"
></i18n>
<template>
  <span
    :class="[
      'inline-flex items-center px-2 py-1 rounded-sm text-xs font-medium ring-1 ring-inset',
      exportation_status.gui
    ]"
  >
    {{ exportation_status.label }}
  </span>
</template>

<script>
export default {
  name: "AEProductionQueryContainerExportExportationStatus",
  props: { status_id: {}, prepend_label: { default: "" } },
  computed: {
    exportation_status: function () {
      if (this.status_id == 0)
        return {
          gui: "bg-yellow-50 text-yellow-800 ring-yellow-600/20",
          label: `${this.prepend_label} ${this.$t("labels.in_preparation")}`
        };
      if (this.status_id == 1)
        return {
          gui: "bg-blue-50 text-blue-800 ring-blue-600/20",
          label: `${this.prepend_label} ${this.$t("labels.in_transit")}`
        };
      if (this.status_id == 2)
        return {
          gui: "bg-[#f0f4e8] text-[#3d5218] ring-[#5c7a2e]/20",
          label: `${this.prepend_label} ${this.$t("labels.arrived")}`
        };
      return {};
    }
  }
};
</script>
